import { render } from "./DinamicTable.vue?vue&type=template&id=d8cfcb18&scoped=true"
import script from "./DinamicTable.vue?vue&type=script&lang=js"
export * from "./DinamicTable.vue?vue&type=script&lang=js"

import "./DinamicTable.vue?vue&type=style&index=0&id=d8cfcb18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8cfcb18"]])

export default __exports__